const buttonNames = [
    'All',
    'Gourmet',
    'Gourmet - XL',

  'Keto',
    'Paleo',
    'Weight Loss',
    'Athlete',
    'Vegan',
    'Breakfast',
  ];
  
  const intervalId = setInterval(() => {
    const targetElement = document.querySelector('.loop-bundle-select-product-title');
    if (targetElement) {
      clearInterval(intervalId);
      const container = document.querySelector('.loop-products-align');
      if (container) {
        const divs = container.getElementsByTagName('div');
        for (let i = 0; i < divs.length; i++) {
          if (divs[i].parentNode === container) {
            divs[i].classList.add('product');
          }
        }
      }
      
      const buttonContainer = document.createElement('div');
      buttonContainer.classList.add('button-container'); // Add a class to the div container
  
      buttonNames.forEach(name => {
        const button = document.createElement('button');
        button.textContent = name;
        button.classList.add('filter_button_loop');
        if(name === 'Gourmet - XL'){
          button.classList.add('new_tag');
        }
        // button.setAttribute('onclick', `${name.replace(/\s/g, '')}`);
        button.setAttribute('onclick', `filterProductsByCategory('${name}')`); // Add brackets () at the end of the value
  
        buttonContainer.appendChild(button);
      });
  
      // targetElement.appendChild(buttonContainer);
      targetElement.insertAdjacentElement('afterend', buttonContainer);

  
      console.log('Code executed successfully!');
    }
  }, 100);
  
  

function filterProductsByCategory(category) {
  const products = document.getElementsByClassName('product');
  for (const product of products) {
    const loopCard = product.querySelector('.loop-card');
    if (!loopCard) {
      continue
    };

    const type = loopCard.getAttribute('data-product-type');
    if (type === category || category === 'All') {
      product.style.display = 'block';
    } else {
      product.style.display = 'none';
    }
  }
}


    const intervalId_filter = setInterval(() => {
      const targetElement = document.querySelector('.loop-bundle-select-product-title');
      const buttons = document.querySelectorAll(".filter_button_loop");
      if (targetElement) {
        clearInterval(intervalId_filter);
      buttons.forEach(button => {
        button.addEventListener("click", () => {
          // Remove "active" class from all buttons
          buttons.forEach(btn => btn.classList.remove("active_filter"));
    
          // Add "active" class to the clicked button
          button.classList.add("active_filter");

        });
      });
      const buttonContainer = document.querySelector('.button-container');
      if (buttonContainer) {
        const firstButton = buttonContainer.querySelector('button');
        if (firstButton) {
          firstButton.classList.add('active_filter');
        }
      }
    }
  }, 100);